import { api } from "./api";

export const categoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => "api/Stock/Categories",
      providesTags: ["categories"],
    }),
    addCategory: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Categories",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["categories"],
    }),
    editCategory: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Categories",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["categories"],
    }),
    deleteCategory: builder.mutation({
      query: (categoryId) => ({
        url: `api/Stock/Categories?CategoryID=${categoryId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["categories"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useEditCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;
